import React, { memo } from 'react'
import {
  AppFooter,
  AppFooterColumbiaContainer,
  AppFooterColumbiaLogo,
  AppFooterText,
  AppFooterContentContainer,
  AppFooterCopyrightContainer,
  AppFooterCopyrightText,
  AppFooterLink,
  AppFooterLinkContainer,
  AppFooterLogo,
  AppFooterLocationContainer,
  AppFooterSocialMedia,
  AppFooterSocialMediaContainer,
  AppFooterMiddleContainer,
} from './styled'
import Logo from 'assets/images/logo.png'
import ColumbiaLogo from 'assets/images/columbia.png'
import FacebookLogo from 'assets/icons/facebook.png'
import TwitterLogo from 'assets/icons/twitter.png'
import InstagramLogo from 'assets/icons/instagram.png'
import YoutubeLogo from 'assets/icons/youtube.png'
import LinkedinLogo from 'assets/icons/linkedin.png'
export default memo(() => {
  return (
    <AppFooter>
      <AppFooterContentContainer>
        <div>
          <AppFooterLogo src={Logo} alt="Acespace Courts" />
        </div>
        <AppFooterMiddleContainer>
          <AppFooterLinkContainer>
            <AppFooterLink to={'/'}>Home</AppFooterLink>
            <AppFooterLink to={'/'}>News</AppFooterLink>
            <AppFooterLink to={'/'}>About</AppFooterLink>
            <AppFooterLink to={'/'}>Contact</AppFooterLink>
            <AppFooterLink to={'/'}>Submit an Issue</AppFooterLink>
          </AppFooterLinkContainer>
          <AppFooterLinkContainer>
            <AppFooterLink to={'/'}>Privacy Policy</AppFooterLink>
            <AppFooterLink to={'/'}>Terms of Use</AppFooterLink>
            <AppFooterLink to={'/'}>Cookie Policy</AppFooterLink>
          </AppFooterLinkContainer>
          <AppFooterColumbiaContainer>
            <AppFooterText>Made with ❤️ in New York</AppFooterText>
            <AppFooterColumbiaLogo
              src={ColumbiaLogo}
              alt="Columbia Startup lab"
            />
          </AppFooterColumbiaContainer>
        </AppFooterMiddleContainer>
        <AppFooterLocationContainer>
          <AppFooterText>AceSpace</AppFooterText>
          <AppFooterText>175 Varick St.</AppFooterText>
          <AppFooterText>New York, NY 10014</AppFooterText>
          <AppFooterSocialMediaContainer>
            <AppFooterSocialMedia src={FacebookLogo} />
            <AppFooterSocialMedia src={TwitterLogo} />
            <AppFooterSocialMedia src={InstagramLogo} />
            <AppFooterSocialMedia src={YoutubeLogo} />
            <AppFooterSocialMedia
              src={LinkedinLogo}
              style={{ marginRight: 0 }}
            />
          </AppFooterSocialMediaContainer>
        </AppFooterLocationContainer>
      </AppFooterContentContainer>

      <AppFooterCopyrightContainer>
        <AppFooterCopyrightText>
          {`Copyright © ${new Date ().getFullYear()} AceSpace Courts All Rights reserved`}
        </AppFooterCopyrightText>
      </AppFooterCopyrightContainer>
    </AppFooter>
  )
})
